import { Injectable } from '@angular/core';

import { CrmOfferLoaderService } from './crm-offer-loader.service';

/**
 * CrmOfferLoaderService facade to expose logic for regulatory promotion restriction
 */
@Injectable({
    providedIn: 'root',
})
export class CrmOfferRestrictionService {
    readonly promoRestricted$ = this.crmOfferLoader.promoRestricted$;

    constructor(private crmOfferLoader: CrmOfferLoaderService) {}
}
